import { MessageCircle, Phone } from "lucide-react";
import { PineappleIcon } from "@/components/PineappleIcon";
import { Reveal } from "@/components/Reveal";
import { PHONE_DISPLAY, waLink } from "@/lib/site";

export const CTABanner = ({
  title = "Collect your keys with confidence.",
  copy = "WhatsApp us your key collection date and flat type — we'll hold an inspection slot for you, usually within a few hours.",
}) => (
  <section className="px-5 py-20 sm:px-8 sm:py-28" data-testid="cta-banner">
    <Reveal className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-charcoal px-6 py-16 text-center sm:px-12 sm:py-20">
      <PineappleIcon
        className="pointer-events-none absolute -left-8 -top-10 h-56 w-40 -rotate-12 text-gold/10"
        strokeWidth={1}
      />
      <PineappleIcon
        className="pointer-events-none absolute -bottom-12 -right-6 h-64 w-44 rotate-12 text-gold/10"
        strokeWidth={1}
      />
      <div className="relative">
        <p className="eyebrow">Book Your Inspection</p>
        <h2 className="mx-auto mt-4 max-w-2xl font-serif text-3xl font-semibold leading-tight text-ivory sm:text-4xl lg:text-5xl">
          {title}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ivory/70 sm:text-base">{copy}</p>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-banner-whatsapp"
            className="inline-flex items-center gap-2 rounded-full bg-wa px-8 py-4 text-sm font-bold text-white shadow-wa transition-transform duration-300 hover:scale-[1.04]"
          >
            <MessageCircle className="h-5 w-5" />
            Book on WhatsApp
          </a>
          <a
            href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`}
            data-testid="cta-banner-call"
            className="inline-flex items-center gap-2 rounded-full border border-ivory/25 px-8 py-4 text-sm font-semibold text-ivory transition-colors duration-300 hover:border-gold-light hover:text-gold-light"
          >
            <Phone className="h-4 w-4" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
